export default "__VITE_ASSET__JGa$DgGb__"